export const STICKY_ACTION_COLUMN_MAX_WIDTH = 60;
export const MAX_CELL_WIDTH = 2000;
export const SELECTION_EXTRA_WIDTH = 72;
export const PINNED_COLUMN_MIN_TABLE_WIDTH = 500;
